<mat-card class="mb-3 mb-md-2 col-md-12 d-flex flex-column h-100 custom-card">
  <mat-card-header>
    <mat-card-title>Resoconto per trimestre</mat-card-title>
    <mat-card-subtitle>Anno selezionato ({{selectedYear}})</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content class="mt-2">
    <div *ngIf="isLoading" class="spinner-container">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>

    <div *ngIf="!isLoading && !errorMessage" style="height: 400px">
      <canvas
        baseChart
        [data]="barChartData"
        [options]="barChartOptions"
        [type]="barChartType"
        [plugins]="barChartPlugins"
      >
      </canvas>
    </div>
  </mat-card-content>

  <mat-card-actions class="d-flex justify-content-end">
    <button mat-raised-button color="primary" (click)="refreshData()">
      Ricarica dati
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-card-actions>

</mat-card>
